<template>

    <section>
        <div v-show="isVisible" :class="{ 'visible': isVisible }" class="back-to-top">
            <div class="feedback-box df jcc aic">
                <img :src="isFeedbackHovered ? feedbackImage2 : feedbackImage1" @click="Onfeedback" alt=""
                    @mouseover="onFeedbackHover" @mouseleave="onFeedbackLeave">
            </div>

            <div class="back-top-box df aic jcc" @click="scrollToTop" @mouseover="onTopHover" @mouseleave="onTopLeave">
                <img :src="isTopHovered ? topImage2 : topImage1" alt="">
            </div>
        </div>

        <!-- 反馈弹框 -->
        <el-dialog :visible.sync="dialogVisible" :title="$t('用户反馈')" width="560px">
            <el-form ref="form" :model="form" class="feedback-form">
                <el-input type="textarea" v-model="form.tufb_content" :placeholder="$t('请输入您的建议和疑问')"></el-input>
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button @click="dialogVisible = false" class="btn1">{{ $t('取消') }}</el-button>
                <el-button type="primary" @click="handleSubmits" class="btn2">{{ $t('提交') }}</el-button>
            </span>
        </el-dialog>

    </section>

</template>

<script>
import { getFeedBack } from "@api/home";
export default {
    data() {
        return {
            isVisible: false,
            isFeedbackHovered: false,
            isTopHovered: false,

            dialogVisible: false,


            form: {
                tufb_content: '',
            },

            feedbackImage1: require('@/assets/images/icon/feedback.png'),
            feedbackImage2: require('@/assets/images/icon/feedback-b.png'),
            topImage1: require('@/assets/images/icon/top.png'),
            topImage2: require('@/assets/images/icon/top-b.png'),
        };
    },
    methods: {
        // 用户反馈
        async handleSubmits() {
            let res = await getFeedBack({ ...this.form });
            if (res.status == 200) {
                this.$message.success(res.msg);
            }
            this.form.tufb_content = "";
            this.dialogVisible = false
        },

        // 反馈
        Onfeedback() {
            this.dialogVisible = true;
        },
        scrollToTop() {
            window.scrollTo({ top: 0, behavior: 'smooth' });
        },
        onFeedbackHover() {
            this.isFeedbackHovered = true;
        },
        onFeedbackLeave() {
            this.isFeedbackHovered = false;
        },
        onTopHover() {
            this.isTopHovered = true;
        },
        onTopLeave() {
            this.isTopHovered = false;
        },
        handleScroll() {
            this.isVisible = window.scrollY > 200; // 当滚动超过200px时显示按钮
        },
    },
    mounted() {
        window.addEventListener('scroll', this.handleScroll);
    },
    beforeDestroy() {
        window.removeEventListener('scroll', this.handleScroll);
    },
};
</script>

<style lang="scss" scoped>
::v-deep() {
    .feedback-form .el-textarea__inner {
        width: 512px;
        height: 125px;
        border-radius: 4px;
        border: none;
        background: rgba(201, 201, 201, 0.2);
        padding: 16px;

        &::placeholder {
            color: rgb(174, 174, 174);
            font-size: 14px;
            font-weight: 400;
            line-height: 22px;
        }
    }

    .el-dialog {
        border-radius: 8px;
        box-shadow: 0px 16px 48px 0px rgba(0, 0, 0, 0.16);
    }

    .el-dialog__header {
        padding: 20px 24px 0px;
    }

    .el-dialog__title {
        color: rgb(25, 25, 25);
        font-size: 16px;
        font-weight: 500;
        line-height: 24px;
    }

    .el-dialog__headerbtn .el-dialog__close {
        color: #191919;

        &:hover {
            color: #B7251E;
        }
    }

    .el-dialog__body {
        padding: 16px 24px 24px;
    }

    .el-dialog__headerbtn {}

    .el-dialog__footer {
        padding: 0 24px 24px;
    }
}

.dialog-footer {
    .btn1 {
        min-width: 88px;
        height: 32px;
        background-color: #ffffff;
        border: 1px solid rgb(201, 201, 201);
        border-radius: 4px;
        color: rgb(25, 25, 25);
        font-size: 14px;
        font-weight: 400;
        padding: 0 16px;

        &:hover {
            border: 0.5px solid rgb(183, 37, 30);
            color: #B7251E;
        }
    }

    .btn2 {
        min-width: 88px;
        height: 32px;
        border: none;
        border-radius: 4px;
        background: rgb(183, 37, 30);
        color: #FFFFFF;
        font-size: 14px;
        font-weight: 400;
        padding: 0 16px;

        &:hover {
            background: rgb(221, 115, 109);
        }
    }
}

.back-to-top {
    position: fixed;
    bottom: 200px;
    left: 20px;
    z-index: 6666666;
    transition: transform 0.3s ease, opacity 0.3s ease;
    transform: translateY(40px);
    opacity: 0;

    /* 初始透明度为0 */
    &.visible {
        transform: translateY(0);
        opacity: 1;
    }

    .feedback-box,
    .back-top-box {
        width: 44px;
        height: 44px;
        border-radius: 50%;
        box-shadow: 0px 1px 12px 0px rgba(0, 0, 0, 0.08);
        background: rgba(255, 255, 255, 0.3);
        margin-top: 12px;
        cursor: pointer;
        transition: all .36s;

        &:hover {
            box-shadow: 0px 1px 12px 0px rgba(0, 0, 0, 0.08);
            background: rgba(216, 216, 216, 0.5);
        }
    }
}
</style>